import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { LocalStorageService } from '@app/services/local-storage.service';
import { NavigationService } from '@app/services/navigation.service';
import { PetService } from '@app/services/pet.service';
import { PetInformationComponent as NewPetInformationComponent } from '../../../../app/components/booking-steps/pet-information/pet-information.component';

@Component({
    selector: 'app-pet-information',
    templateUrl: './pet-information.component.html',
    styleUrls: ['./pet-information.component.scss'],
    standalone: false,
})
export class PetInformationComponent extends NewPetInformationComponent {
    constructor(
        private _petService: PetService,
        private _fb: FormBuilder,
        private _navigationService: NavigationService,
        private _localStorageService: LocalStorageService
    ) {
        super(_petService, _fb, _navigationService, _localStorageService);
    }
}
